import { george, i18n, pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import { useEffect } from "react";
import { Redirect, RouteComponentProps } from "react-router";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { BSPOptionsRoutes } from "./BSPOptionsRoutes";
import { BSPOptionsStore } from "./BSPOptionsStore";
import { BSPOptionsInfoBox } from "./components/BSPOptionsInfoBox";


type IProps = RouteComponentProps<{ id: string }> & i18n.InjectedIntlProps & {
    store: BSPOptionsStore;
};

export const BSPOptionsPayoutRedirect = observer(({ store }: IProps) => {
    useEffect(() => {
        const initData = async () => {
            await store.loadPayoutData();
        };
        initData();
    }, []);

    const BackgroundComponent = externalInterfaceStore.isGeorgeApp ? george.Background : george.BackgroundWithNavBar;

    if (store.isLoading) {
        return (
            <BackgroundComponent>
                <george.LoadingIndicator isLoading={store.isLoading} height={ui.windowHeight} />
            </BackgroundComponent>
        );
    }

    if (store.selectedPayout === "payout" || store.selectedPayout === "payoutLegalGuardian") {
        return <Redirect to={`${BSPOptionsRoutes.SUMMARY}${location.search}`} />;
    }

    return (
        <BackgroundComponent style={{ paddingTop: 48, paddingBottom: theme.MARGIN }}>
            <BSPOptionsInfoBox>
                <pr.P_16_CONTENT>
                    {ui.__("bspOptions.overview.infoBox.invalidContract")}
                </pr.P_16_CONTENT>
            </BSPOptionsInfoBox>
        </BackgroundComponent>
    );
});


// WEBPACK FOOTER //
// ./src/components/BSPOptions/BSPOptionsPayoutRedirect.tsx